import { query, collection, orderBy, onSnapshot, setDoc, doc, addDoc, deleteDoc, serverTimestamp, startAfter, limit, getDocs, where } from "firebase/firestore";
import { call } from "ionicons/icons";
import { db, getCompanyId, getCurrentUser, getCurrentUserUID, sendError } from "./firebase";

const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotList: any[] = [];
var lastSnapshotMap = new Map();
var clientByPhoneMap = new Map();
var lastItem: any = undefined;
var lastClientId:string = "";
var listener:CallableFunction;

export function cleanupClientComments(){
    
    if(snapshotListener !== null){
        snapshotListener();
        snapshotListener = null;
    }
    lastClientId = "";
    lastItem = undefined;
    lastSnapshotList = [];
}

export function registerClientCommentsSnapshotListener(clientId:string,  callback: CallableFunction) {
    listener = callback;
    if(clientId === lastClientId){
        listener(lastSnapshotList);
        return;
    }
    cleanupClientComments();
    var q;
    q = query(collection(db, 'companies/' + getCompanyId() + '/clients/' + clientId + "/comments"), orderBy("created", "desc"), limit(20));
    // if(getCurrentUser().role === "manager"){
    //     q = query(collection(db, 'companies/' + getCompanyId() + '/clients/' + clientId + "/comments"), orderBy("created", "desc"), limit(10));
    // }else{
    //     q = query(collection(db, 'companies/' + getCompanyId() + '/clients/' + clientId + "/comments"), where("userId", "==", getCurrentUserUID()), orderBy("created", "desc"), limit(10));
    // }
    
    //console.log("register registerClientCommentsSnapshotListener");
    lastItem = undefined;
    lastClientId = clientId;
    snapshotListener =  onSnapshot(q, (data: any) => {
        var list: any[] = [];
        data.forEach(function (doc: any) {
            const d = doc.data();
            //console.log("clientComments", d);
            list.push({ ...d, id: doc.id });
            
            
        });
        lastSnapshotList = list;
        listener(list);
        if (lastItem === undefined) {
            lastItem = data.docs[data.docs.length - 1];
        }
    }, (err) => {
        console.log("onClientComments error => " + err.message);
        sendError(err.message);
    })
}


export async function getMoreClientComments(clientId: string) {
    //console.log("getClientComments")

    var list: any[] = [];
    if (lastItem !== undefined) {
        var q = query(collection(db, 'companies/' + getCompanyId() + '/clients/' + clientId + "/comments"), orderBy("created", "desc"), startAfter(lastItem), limit(10));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const d = doc.data();
            list.push({ ...d, id: doc.id });
            lastSnapshotList.push({ ...d, id: doc.id });
        });
        if (querySnapshot.docs.length > 0) {
            lastItem = querySnapshot.docs[querySnapshot.docs.length - 1];
        } else {
            lastItem = undefined;
        }
    }
    return list;
}

export async function addClientComment(data: any) {
    var saveData = {
        topic: data.topic ?? '',
        comment: data.comment ?? ''
    };

    //@ts-ignore
    saveData.userIdUpdate = getCurrentUserUID();

    if (data.id !== null && data.id !== undefined) {
        //@ts-ignore
        saveData.lastUpdated = data.updated;
        //@ts-ignore
        saveData.updated = serverTimestamp();
        try {
            await setDoc(doc(db, 'companies/' + getCompanyId() + '/clients/'+lastClientId+"/comments", data.id), saveData, {merge:true});
            return true;
        } catch (e) {
            console.error(e);
            sendError("Nie mozna poprawić notatki!");
        }

    } else {

        //@ts-ignore
        saveData.created = serverTimestamp();
        //@ts-ignore
        saveData.updated = serverTimestamp();
        //@ts-ignore
        saveData.lastUpdated = serverTimestamp();
        //@ts-ignore
        saveData.userId = getCurrentUserUID();
        try {
            await addDoc(collection(db, 'companies/' + getCompanyId() + '/clients/'+lastClientId+"/comments"), saveData);
            return true;
        } catch (e) {
            console.error(e);
            sendError("Nie mozna dodać notatki!");
        }
    }
    return false;
}

export function getClientComment(id:string){
    for(var i=0; i<lastSnapshotList.length; i++){
        if(lastSnapshotList[i].id === id){
            return lastSnapshotList[i];
        }
    }
    return undefined;
}


export async function removeClientComment(id:string){
    try {
        await deleteDoc(doc(db, 'companies/' + getCompanyId() + '/clients/'+lastClientId+"/comments", id));
        return true;
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć notatki!");
    }
    return false;
}
